import { ChangeDetectionStrategy, Component, effect, inject } from '@angular/core';
import { NgbTypeaheadModule, NgbTypeaheadSelectItemEvent } from '@ng-bootstrap/ng-bootstrap';
import { SearchItems } from '../../core';
import { DashboardService } from '../../services';
import { BaseComponent } from '../../shared';


/**
 * Dashboard filters component.
 */
@Component({
	selector: 'dashboard-filters',
	templateUrl: './dashboard-filters.component.html',
	imports: [
		NgbTypeaheadModule
	],
	changeDetection: ChangeDetectionStrategy.Eager
})
export class DashboardFiltersComponent extends BaseComponent {

	private readonly dashbrdSrv = inject(DashboardService);

	currentPatient: string = '';

	private readonly init = effect(() => this.dashbrdSrv.loadPatientList());

	/**
	* Display name of selected patient.
	*/
	patientFormatter = (result: SearchItems) => result.patientNumber;

	/**
	* Function that filter the patients in autocomplete form.
	*/
	filterPatients = this.dashbrdSrv.filterPatients;

	/**
	* Show options of autocomplete form on focus.
	*/
	showPatientList(element: any): void {
		(element?._nativeElement as HTMLInputElement).dispatchEvent(new Event('input'));
		(element?._nativeElement as HTMLInputElement).focus();
	}

	/**
	 * Update selected patient.
	 */
	updatePatient(event: NgbTypeaheadSelectItemEvent<SearchItems>, element: any): void {
		event.preventDefault();
		this.currentPatient = event.item.patientNumber;
		(element?._nativeElement as HTMLInputElement).value = event.item.patientNumber;
		(element?._nativeElement as HTMLInputElement).blur();
		this.dashbrdSrv.filterEvents(event.item.patientId);
	}

	/**
	 * Reset patient filter.
	 */
	reset(element: any): void {
		const currentValue = (element?._nativeElement as HTMLInputElement).value;
		if (currentValue != this.currentPatient) {
			this._clearFilter(element);
		}
	}

	/**
	 * Clear selected patient.
	 */
	clear(element: any): void {
		const currentValue = (element?._nativeElement as HTMLInputElement).value;
		if (this.currentPatient || currentValue) {
			this._clearFilter(element);
		}
	}

	private _clearFilter(element: any): void {
		(element?._nativeElement as HTMLInputElement).value = '';
		this.currentPatient = '';
		this.dashbrdSrv.filterEvents(null);
	}
}